import { FaRunning } from "react-icons/fa"
import { IoSnowOutline } from "react-icons/io5"
import { MdSettingsPower } from "react-icons/md"
import { RiAlarmWarningLine } from "react-icons/ri"
import { IconFilter } from "../../SubPlants/SP_Filter/IconFilter"
import { schema as defaultSchema, schemaFilter, schemaFreeze, schemaMotion, schemaRepairSwitch } from "./types"

export const Icon = (props: any) => {
    if (props.schema === schemaFreeze)
        return (<IoSnowOutline {...props}></IoSnowOutline>)

    if (props.schema === schemaRepairSwitch)
        return (<MdSettingsPower {...props}></MdSettingsPower>)

    if (props.schema === schemaMotion)
        return (<FaRunning {...props}></FaRunning>)

    if (props.schema === schemaFilter)
        return (<IconFilter width={props.size} height={props.size} {...props}></IconFilter>)


    return (<RiAlarmWarningLine {...props}></RiAlarmWarningLine>)
}